// Redimensiona fotos do celular no navegador antes do upload (evita HEIC/15MB travando a tela).
const MAX_DIM = 1600;
const QUALITY = 0.82;

const loadBitmap = async (file) => {
  if (window.createImageBitmap) {
    try { return await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (e) {}
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
};

export const resizeImage = async (file) => {
  if (!file.type.startsWith('image/') && !/\.(heic|heif)$/i.test(file.name)) return file;
  try {
    const bmp = await loadBitmap(file);
    const w = bmp.width || bmp.naturalWidth; const h = bmp.height || bmp.naturalHeight;
    if (!w || !h) return file;
    const scale = Math.min(1, MAX_DIM / Math.max(w, h));
    if (scale === 1 && file.size < 1.2 * 1024 * 1024 && /jpe?g|png|webp/i.test(file.type)) return file;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(w * scale); canvas.height = Math.round(h * scale);
    canvas.getContext('2d').drawImage(bmp, 0, 0, canvas.width, canvas.height);
    if (bmp.close) bmp.close();
    const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', QUALITY));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch (e) {
    return file; // servidor converte HEIC/redimensiona como segunda barreira
  }
};
